import { t } from 'typy'

export function copyToClipboard (dataString) {
    if (!t(dataString).isString) {
        throw new TypeError(`Invalid argument type. Expecting a string instead received a ${typeof dataString}.`)
    }

    return navigator.clipboard.writeText(dataString) // Promise
}
